import { CookieService } from 'ngx-cookie-service';
import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Client } from './client';
import { environment } from 'environments/environment';
import getToken from '@app/utils/get-token';

@Injectable()
export class AutheticationService {
  auth: Subject<boolean> = new Subject();

  constructor(
    private http: HttpClient,
    private client: Client,
    private cookieService: CookieService,
    private zone: NgZone
  ) {
    this.zone.runOutsideAngular(() => {
      setTimeout(() => {
        getToken(this.cookieService);
      }, 1000);
    });
  }

  authUser(userBody): Observable<any> {
    let userInfo;
    if (userBody.otp === '') {
      userInfo = { name: userBody.name, password: userBody.password };
    } else {
      userInfo = userBody;
    }

    return this.http.post('operator/login', userInfo);
  }

  logOut() {
    localStorage.removeItem('autheticationStatus');
    localStorage.removeItem('token');
    this.cookieService.delete('token', '/', this.getDomainWithDot());
    localStorage.removeItem('user_id');
    localStorage.removeItem('timeDiff');
  }

  getLocalStorage(id) {
    if (id === 'token') {
      return getToken(this.cookieService);
    } else {
      return localStorage.getItem(id);
    }
  }

  setToken(token) {
    if (location.hostname === 'localhost') {
      localStorage.setItem('token', token);
    } else {
      this.cookieService.set('token', token, 356, '/', this.getDomainWithDot(), false, 'Lax');
    }
  }

  private getDomainWithDot() {
    let domain;
    if (environment.config.domain.charAt(0) === '.') {
      // .utaxcloud.net
      domain = environment.config.domain;
    } else {
      // dev-miranda.megakit.pro',
      const splitedDomain = environment.config.domain.split('.');
      domain = `.${splitedDomain[1]}.${splitedDomain[2]}`;
    }
    return domain;
  }

  isToken(): boolean {
    return !!getToken(this.cookieService);
  }

  getPermision() {
    return this.http.get(this.client.getUserPermisionUrl());
  }

  whoAmI(): Observable<any> {
    return this.http.get(this.client.getWhoamiUrl());
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/authetication.service.ts